import clsx from 'clsx';
import RadioGroupButtons from '../radio-group/RadioGroupButtons';
import { SortDirection, SortOption } from './sort.types';

type SortMenuProps = {
    dir: SortDirection;
    field: string;
    options: SortOption[];
    onDirectionChange: (dir: SortDirection) => void;
    onOptionChange: (opt: string) => void;
};

function SortMenu({ dir, field, options, onDirectionChange, onOptionChange }: SortMenuProps): JSX.Element {
    return (
        <div>
            <div className="border-b pb-2">
                <RadioGroupButtons
                    options={[
                        { label: 'Ascending', value: 'asc' },
                        { label: 'Descending', value: 'desc' },
                    ]}
                    groupName="sort-order"
                    value={dir}
                    onChange={(e): void => {
                        onDirectionChange(e.target.value as SortDirection);
                    }}
                />
            </div>

            <ul className="flex flex-col my-1 max-h-[300px] overflow-scroll">
                {options.map((option) => {
                    const isChecked = option.value === field;
                    return (
                        <li key={option.value}>
                            <label
                                htmlFor={`radio-${option.value}`}
                                className={clsx(
                                    'flex items-center cursor-pointer  rounded-md text-sm text-gray-700 gap-2 py-2 px-1 border',
                                    isChecked ? 'bg-indigo-50 border-indigo-600' : 'border-transparent'
                                )}
                            >
                                <input
                                    id={`radio-${option.value}`}
                                    className="focus:ring-0 h-4 w-4 text-indigo-600 border-gray-300"
                                    type="radio"
                                    name="sort"
                                    value={option.value}
                                    checked={isChecked}
                                    onChange={(e): void => onOptionChange(e.target.value)}
                                />
                                {option.label}
                            </label>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default SortMenu;
